<mat-card>
  <mat-card-header>
    <mat-card-title>{{ title }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    @if (isLoading) {
      <div class="table-loading">
        <p>Loading table data...</p>
      </div>
    } @else if (tableRows().length > 0) {
      <app-generic-table
        [data]="tableRows()"
        [columns]="columns()"
        [config]="tableConfig()">
      </app-generic-table>
    } @else {
      <p class="placeholder-text">No data available for this table</p>
    }
  </mat-card-content>
</mat-card>
